import React, { useEffect, useState } from 'react';
import HorizontalBarChart from '../diagrams/HorizontalBarChart';
import Modal from '../utils/Modal'; 
import { CountriesDB } from '../db/CountriesDB';
import { Utils } from '../utils/Utils';

function LeagueStats(teams) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState([]);

  const getDistinctCountries = async (stats) => {
    const countries = Array.from(new Set(stats.map(stat => stat.countryLastTeam)));
    console.log({countries})
    return await CountriesDB.getDistinct(countries)
  }

  useEffect(() => {

    const getLeagueStats = () => {
      return Array.from(
          teams.teams
            .flatMap(team => team.players)
            .reduce((acc, player) => {
              if( player !== undefined && player.countryLastTeam !== undefined && player.categoryLastTeam !== undefined) {
                const key = `${player.countryLastTeam}||${player.categoryLastTeam}`;
                if (!acc.has(key)) {
                  acc.set(key, {
                    countryLastTeam: player.countryLastTeam,
                    categoryLastTeam: player.categoryLastTeam,
                    count: 1
                  });
                } else {
                  acc.get(key).count++;
                }
              }
              return acc;
            }, new Map())
          .values()
        ).sort((a, b) => b.count - a.count);
    }
  
    const parseStats = async (stats) => {
      if (stats.length > 0) {
        return await getDistinctCountries(stats).then(countries => {
          return stats.map(stat => ({
            name: Utils.showFlagCountry(countries, stat.countryLastTeam, true) + '&nbsp;' + stat.categoryLastTeam ,
            value: stat.count
          }));
        });
      }
    }

    parseStats(getLeagueStats()).then(stats => {
      setTotalData(stats)
      setData(stats.slice(0,6))
    });
  
  }, [teams.teams]);

  return (
    <div>
      <p><b>Número de jugadores en base a la liga en la que han jugado en la temporada anterior</b></p>
      <HorizontalBarChart data={data}/>
      <button className="btn-all-data" onClick={() => setIsModalOpen(true)}>
        Ver todos los datos
      </button>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <table className="table-stats">
          <thead>
            <tr>
              <th>Liga</th>
              <th>Nº de jugadores</th>
            </tr>
          </thead>
          <tbody>
          {totalData.map((item, index) => (
            <tr key={index}>
              <td><div className="label-country" dangerouslySetInnerHTML={{ __html: item.name }}></div></td><td className="td-value"> {item.value}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </Modal>
    </div>
  )
}

export default LeagueStats